import { createClient } from "@supabase/supabase-js";

/** Both values are safe in a client bundle. The anon key identifies the project,
 *  not a user, and can only do what the RLS policies in V2 permit. */
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail loudly and early. A missing env var otherwise surfaces as a confusing
// network error on the first query, long after the actual mistake.
if (!url || !anonKey) {
  const missing = [
    !url && "VITE_SUPABASE_URL",
    !anonKey && "VITE_SUPABASE_ANON_KEY",
  ]
    .filter(Boolean)
    .join(" and ");
  throw new Error(
    `Missing ${missing}. Copy .env.example to .env.local, fill in the values from ` +
      `Supabase → Project Settings → API, then restart the dev server.`,
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Needed for the OAuth redirect: the session arrives in the URL fragment
    // and has to be picked up on load.
    detectSessionInUrl: true,
  },
});
